import { render } from "./incoming-outgoing-cargo-table.vue?vue&type=template&id=1744804f&scoped=true&ts=true"
import script from "./incoming-outgoing-cargo-table.vue?vue&type=script&lang=ts"
export * from "./incoming-outgoing-cargo-table.vue?vue&type=script&lang=ts"

import "./incoming-outgoing-cargo-table.vue?vue&type=style&index=0&id=1744804f&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1744804f"]])

export default __exports__